// Attach the customer drawing (PDF) and customer model (STEP) to the item, after Save and
// Submit has it -- api/customer-files makes both with the Sales Burner Configurator from the
// same burner the live model shows (profile.burnerModel), and links them to
// custitem_customer_drawing / custitem_customer_model.
//
// Fired keepalive, like finish-assembly: the tab closes back to the sales order a moment
// later, and nothing on the order needs these files. Only the configuration goes over (a few
// KB, inside keepalive's 64 KB); the server makes the files. A failure lands in
// cpq2_error_log, and re-running Save and Submit repeats it without duplicating anything.
import { getProfile } from "../products";
import { fireBackground } from "./netsuiteClient";
import type { AnswerState } from "../types";

export function attachCustomerFiles(args: {
  slug: string;
  answers: AnswerState;
  itemId: string | number;
  itemName: string | null | undefined;
  customer: string | null | undefined;
  /** "replace": this item was just built or edited, so cpq2's own files are rewritten.
   *  "fill": an existing item matched by fingerprint, so only an empty field is filled. */
  mode: "replace" | "fill";
  actor?: { id?: string | number | null; name?: string | null };
}): boolean {
  const model = getProfile(args.slug).burnerModel?.(args.answers);
  if (!model || !args.itemName) return false;
  const d = new Date();
  fireBackground("/customer-files", {
    itemId: String(args.itemId),
    itemName: args.itemName,
    config: model.config,
    customer: args.customer || "",
    // The user's date: the server runs on UTC, which dates an afternoon's sheet tomorrow.
    date: `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`,
    mode: args.mode,
    actor: args.actor,
  });
  return true;
}
